module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container_right"
  }, [_c('div', {
    staticClass: "container_right_hotrecommend"
  }, [_c('div', {
    staticClass: "container_right_hotrecommend_icon"
  }, [_vm._v("热门推荐")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_hotrecommend_font"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "container_right_hotrecommend_font"
    }, [_c('li', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name: 'CmsDetail', query: {id: item.id}}"
      }]
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "container_right_doublecode"
  }, [_c('div', {
    staticClass: "container_right_doublecode_img"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_right_doublecode_font"
  }, [_c('div', {
    staticClass: "container_right_doublecode_font_up"
  }, [_vm._v("更多精彩内容")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_doublecode_font_down"
  }, [_vm._v("\n            请关注CCA官方公众号\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecb2928c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainindex/RightNav.vue
// module id = 1567
// module chunks = 0